import  React from 'react';
import './index.css';
import MainSection from '../Mainsection';
import VisitorCounter from '../VisitorCount';

function HomePage(){
    return (
      <>
      
      <MainSection/>


      

      <VisitorCounter/>

      </>
  );
};
  
export default HomePage;